// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"cac371dd","155":"ba7f7d05","171":"9c7140f3","400":"b5068637","895":"c321996c"}[chunkId] + ".chunk.js";
};